import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { BarLoader, ClipLoader } from 'react-spinners'
import { debounce, isEmpty, isObject } from 'lodash'
import { withRoutingTracker } from '../HOC/withRoutingTracker.js'
import CoCartAPI from '@cocart/cocart-rest-api'
import { APP_URL } from '../utils/config.js'
import { getFabricsForKits, getWestchaseFabrics } from '../actions/fabricsActions.js'
import { displayToast } from '../utils/utils.js'
import { getAttributeTermsById } from '../actions/cushionActions.js'
import '../../css/App.scss'
import {
  getKits,
  setSelectedKitCordingFabrics,
  setSelectedKitFabrics,
  setSelectedKitFillings,
  setSelectedKitQty,
  setSelectedKitSize,
  setSelectedKitStyle,
} from '../actions/kitActions.js'

const CoCart = new CoCartAPI({
  url: APP_URL,
})

class Kit extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isMobileLayout: false,
      isDesktopLayout: false,
      fabrics: [],
      disabeled: true,
      kits: [],
      kitsDetails: null,
      kit: null,
      kitFabrics: [],
      kitCordingFabrics: [],
      kitFabricsLength: null,
      addToCartPressed: false,
      selectedFabricName: null,
      selectedCordingFabricName: null,
      selectedFiling: null,
      fillings: [],
      kitFillings: [],
      kitQty: 1,
      kitQtyInputWidth: '35px',
      directionalFabricsOptions: [
        {
          id: 1,
          fabric_direction: 'vertical',
          fabric_direction_name: 'Vertical (Top-to-Bottom, Front-to-Back)',
        },
        {
          id: 2,
          fabric_direction: 'horizontal',
          fabric_direction_name: 'Horizontal (Side-to-Side, Left-to-Right)',
        },
      ],
      lastKitSelection: null,
      cartResponses: [],
      shapes: [],
      fasteners: [],
      styles: [],
      showCordingFabrics: true,
      doesClientWantsFabricsAutoselected: false,
    }
  }

  componentDidMount() {
    const { doesClientWantsFabricsAutoselected, directionalFabricsOptions } = this.state
    const { general, kit: kitProps } = this.props
    const {
      style,
      nameOfStyle,
      size,
      fabricsSet,
      cordingFabricsSet,
      fillingsSet,
      fabricsDirection,
      kitQty,
    } = kitProps

    if (window.innerWidth < 1024) {
      this.setState({ isMobileLayout: true })
    }

    window.addEventListener('resize', this.checkForMobileLayout)
    window.addEventListener('resize', this.checkForDesktopLayout)
    window.addEventListener('load', this.checkForMobileLayout)

    this._getAllFabrics()
    this._getKits()
    this._getFillings()
    this._getShapes()
    this._getFasteners()
    this._getStyles()

    if (general.kits) {
      this.setState({ kits: general.kits })
    }

    if (style) {
      this.setState({
        kitsDetails: style,
      })
    }
    if (size) {
      this.setState({
        kit: size,
        kitFabricsLength: Object.keys(size).length,
      })
    }
    if (fillingsSet) {
      this.setState({
        kitFillings: fillingsSet,
      })
    }
    if (doesClientWantsFabricsAutoselected) {
      if (fabricsSet) {
        for (let i = 0; i < fabricsSet.length; i++) {
          this.setState({
            [`kitFabric${i}`]: fabricsSet[i],
          })
          if (fabricsDirection[i]?.fabric_direction) {
            this.setState({
              [`kitFabricDirection${i}`]: {
                fabric_direction: fabricsDirection[i].fabric_direction,
                fabric_direction_name: directionalFabricsOptions.find(
                  (fabric) => fabric.fabric_direction === fabricsDirection[i].fabric_direction,
                ).fabric_direction_name,
              },
            })
          } else {
            this.setState({
              [`kitFabricDirection${i}`]: undefined,
            })
          }
        }
      }
      if (cordingFabricsSet) {
        for (let i = 0; i < cordingFabricsSet.length; i++) {
          this.setState({
            [`kitCordingFabric${i}`]: cordingFabricsSet[i],
          })
        }
      }
    }
    if (nameOfStyle) {
      if (nameOfStyle.toLowerCase().includes('style 6')) {
        this.setState({
          showCordingFabrics: false,
        })
      } else {
        this.setState({
          showCordingFabrics: true,
        })
      }
    }
    if (kitQty) {
      this.setState({
        kitQty: kitQty,
      })
    }

    this.forceUpdate()
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      kitFabricsLength,
      kit,
      kitsDetails,
      lastKitSelection,
      cartResponses,
      kitFillings,
      kits,
      directionalFabricsOptions,
      doesClientWantsFabricsAutoselected,
    } = this.state
    const { dispatch, kit: kitProps, fabrics } = this.props
    const { fabricsKits } = fabrics
    const { nameOfStyle, nameOfSize, kitQty } = kitProps

    if (kit) {
      const indexes = Array.from({ length: kitFabricsLength }, (v, k) => k)
      const truthOrFalseDropdown = indexes.map((index) => {
        // eslint-disable-next-line react/destructuring-assignment
        let dropdownState = this.state[`kitFabric${index}`]
        return !isEmpty(dropdownState)
      })
      const truthOrFalseCondition = indexes.map((index) => {
        // eslint-disable-next-line react/destructuring-assignment
        let directionState = this.state[`kitFabricDirection${index}`]

        if (isObject(directionState) && !isEmpty(directionState)) {
          return true
        }
        if (isObject(directionState)) {
          return false
        }
        if (directionState === undefined) {
          return ''
        }
      })

      const diectionArray = truthOrFalseCondition.filter((item) => item !== '')

      if (
        truthOrFalseDropdown.every((item) => item === true) &&
        diectionArray.every((item) => item === true)
      ) {
        this.setState({ disabeled: false })
      } else {
        this.setState({ disabeled: true })
      }
    }

    if (prevState.kitsDetails !== kitsDetails) {
      if (lastKitSelection && kitsDetails) {
        let kit = kitsDetails[lastKitSelection]

        this.setState(
          {
            kitFabrics: [],
            kitCordingFabrics: [],
            kit: kit,
            kitFabricsLength: Object.keys(kit)?.length,
          },
          () => {
            this._setFillings()
            this._setDropdownsState()
          },
        )
      }
      if (kitsDetails === undefined) {
        this._clear()
      }
    }

    const kitQtyStorage = window.sessionStorage.getItem('kit_qty')
    const kitStyleNameStorage = window.sessionStorage.getItem('kit_style_name')
    const kitSizeNameStorage = window.sessionStorage.getItem('kit_size_name')
    const kitFabricsStorage = window.sessionStorage.getItem('kit_fabrics')
    const kitFabricsDirectionsStorage = window.sessionStorage.getItem('kit_fabrics_directions')
    const kitCordingFabricsStorage = window.sessionStorage.getItem('kit_cording_fabrics')
    const kitFillingsStorage = window.sessionStorage.getItem('kit_fillings')

    if (prevProps.fabrics.fabricsKits !== fabricsKits && kitStyleNameStorage) {
      // set kitDetails
      const kitStyleStorage = kits[kitStyleNameStorage]

      if (kitStyleStorage) {
        this.setState({
          kitsDetails: kitStyleStorage,
        })
        dispatch(setSelectedKitStyle(kitStyleStorage, kitStyleNameStorage))
      }
      if (kitStyleNameStorage) {
        if (kitStyleNameStorage.toLowerCase().includes('style 6')) {
          this.setState({
            showCordingFabrics: false,
          })
        } else {
          this.setState({
            showCordingFabrics: true,
          })
        }
      }

      // set kit and fabricsLength
      const kitSizeStorage = kits[kitStyleNameStorage][kitSizeNameStorage]

      if (kitSizeStorage) {
        this.setState({
          kit: kitSizeStorage,
          kitFabricsLength: Object.keys(kitSizeStorage).length,
        })
        dispatch(setSelectedKitSize(kitSizeStorage, kitSizeNameStorage))
      }

      const fabricsSet = []
      const fabricsDirectionsSet = []
      const cordingFabricsSet = []
      const fillingsSet = []

      // set fillings array
      JSON.parse(kitFillingsStorage)?.forEach((filling) => {
        fillingsSet.push(filling)
      })

      if (fillingsSet) {
        this.setState({
          kitFillings: fillingsSet,
        })
      }

      // set kit qty
      if (kitQtyStorage) {
        this.setState({
          kitQty: kitQtyStorage,
        })
      }

      if (doesClientWantsFabricsAutoselected) {
        // set fabrics set
        JSON.parse(kitFabricsStorage)?.forEach((id) => {
          if (fabricsKits?.find((fabric) => fabric.id === id)) {
            fabricsSet.push(fabricsKits?.find((fabric) => fabric.id === id))
          }
        })

        // set fabrics directions
        JSON.parse(kitFabricsDirectionsStorage)?.forEach((direction) => {
          fabricsDirectionsSet.push(direction)
        })

        if (fabricsSet) {
          for (let i = 0; i < fabricsSet.length; i++) {
            this.setState({
              [`kitFabric${i}`]: fabricsSet[i],
            })
            if (fabricsDirectionsSet[i]?.fabric_direction) {
              this.setState({
                [`kitFabricDirection${i}`]: {
                  fabric_direction: fabricsDirectionsSet[i].fabric_direction,
                  fabric_direction_name: directionalFabricsOptions.find(
                    (fabric) =>
                      fabric.fabric_direction === fabricsDirectionsSet[i].fabric_direction,
                  ).fabric_direction_name,
                },
              })
            } else {
              this.setState({
                [`kitFabricDirection${i}`]: undefined,
              })
            }
          }
        }

        // set cording fabrics set
        JSON.parse(kitCordingFabricsStorage)?.forEach((id) => {
          if (fabricsKits?.find((fabric) => fabric.id === id)) {
            cordingFabricsSet.push(fabricsKits?.find((fabric) => fabric.id === id))
          }
        })

        if (cordingFabricsSet) {
          for (let i = 0; i < cordingFabricsSet.length; i++) {
            this.setState({
              [`kitCordingFabric${i}`]: cordingFabricsSet[i],
            })
          }
        }
      }

      let kit = kits[kitStyleNameStorage]
      let isStyle6Selected = kitStyleNameStorage.toLowerCase().includes('style 6')
      let numberOfItemsThatDoNotRequireCordingFabrics = 0
      let numberOfItemsInKit = 0
      let kitProducts = []

      for (let key in kit) {
        kitProducts.push(kit[key])
      }

      kitProducts.forEach((product) => {
        let productItems = []
        for (let key2 in product) {
          productItems.push(product[key2])
        }

        productItems.forEach((item) => {
          numberOfItemsInKit++
          if (
            item[0]['ordering notes']?.toLowerCase().includes('knife edge') ||
            item[0]['ordering notes']?.toLowerCase().includes('no welting')
          ) {
            numberOfItemsThatDoNotRequireCordingFabrics++
          }
        })
      })

      let allItemsDoNotRequireCordingFabrics =
        numberOfItemsThatDoNotRequireCordingFabrics === numberOfItemsInKit

      if (isStyle6Selected || allItemsDoNotRequireCordingFabrics) {
        this.setState({
          showCordingFabrics: false,
        })
      } else {
        this.setState({
          showCordingFabrics: true,
        })
      }

      this.forceUpdate()
    }

    // check if cartResponses has changed and it's equal to kitFabricsLength
    if (prevState.cartResponses !== cartResponses && cartResponses.length === kitFabricsLength) {
      setTimeout(() => {
        window.sessionStorage.removeItem('kit_qty')
        window.sessionStorage.removeItem('kit_style_name')
        window.sessionStorage.removeItem('kit_size_name')
        window.sessionStorage.removeItem('kit_fillings')
        window.sessionStorage.setItem('kit_qty', kitQty)
        window.sessionStorage.setItem('kit_style_name', nameOfStyle)
        window.sessionStorage.setItem('kit_size_name', nameOfSize)
        window.sessionStorage.setItem('kit_fillings', JSON.stringify(kitFillings))
        if (doesClientWantsFabricsAutoselected) {
          window.sessionStorage.removeItem('kit_fabrics')
          window.sessionStorage.removeItem('kit_fabrics_directions')
          window.sessionStorage.removeItem('kit_cording_fabrics')
          const fabricsArray = []
          const cordingFabricsArray = []
          const fabricsDirection = []
          for (let i = 0; i < Object.keys(kit).length; i++) {
            // eslint-disable-next-line react/destructuring-assignment
            fabricsArray.push(this.state[`kitFabric${i}`])
            // eslint-disable-next-line react/destructuring-assignment
            cordingFabricsArray.push(this.state[`kitCordingFabric${i}`])
            // eslint-disable-next-line react/destructuring-assignment
            fabricsDirection.push(this.state[`kitFabricDirection${i}`])
          }
          dispatch(setSelectedKitFabrics(fabricsArray, fabricsDirection))
          dispatch(setSelectedKitCordingFabrics(cordingFabricsArray))
          dispatch(setSelectedKitFillings(kitFillings))
          // save all ids from fabricsArray in a separate array
          const fabricsIds = fabricsArray.map((fabric) => fabric.id)
          const cordingFabricsIds = cordingFabricsArray.map((fabric) => fabric.id)
          window.sessionStorage.setItem('kit_fabrics', JSON.stringify(fabricsIds))
          window.sessionStorage.setItem('kit_fabrics_directions', JSON.stringify(fabricsDirection))
          window.sessionStorage.setItem('kit_cording_fabrics', JSON.stringify(cordingFabricsIds))
        }
      }, 100)
    }
  }

  _setQty = (e) => {
    const { dispatch } = this.props
    if (e.target.value > 9) {
      this.setState({ kitQtyInputWidth: '50px' })
    }
    if (e.target.value < 10) {
      this.setState({ kitQtyInputWidth: '35px' })
    }
    if (e.target.value > 99) {
      displayToast('Maximum quantity is 99', 'info')
    }
    dispatch(setSelectedKitQty(e.target.value))
    this.setState({
      kitQty: e.target.value > 99 ? 99 : e.target.value,
    })
  }

  _setDropdownsState = () => {
    const { kit } = this.state
    if (kit) {
      Object.keys(kit).map((k, index) => {
        this.setState({
          [`kitFabric${index}`]: {},
          [`kitCordingFabric${index}`]: {},
        })
      })
    }
  }

  _getFillings = () => {
    getAttributeTermsById(15).then((fillings) => {
      let fillingsWithoutLoosePolyester = fillings?.filter(
        (filling) => filling.id !== 796 && filling.id !== 725 && filling.id !== 862,
      )
      this.setState({
        fillings: fillingsWithoutLoosePolyester,
      })
    })
  }

  _getShapes = () => {
    getAttributeTermsById(4).then((shapes) => {
      this.setState({
        shapes: shapes,
      })
    })
  }

  _getFasteners = () => {
    getAttributeTermsById(14).then((fasteners) => {
      this.setState({
        fasteners: fasteners,
      })
    })
  }

  _getStyles = () => {
    getAttributeTermsById(18).then((styles) => {
      this.setState({
        styles: styles,
      })
    })
  }

  _setFillingsBasedOnId = (id) => {
    const { fillings } = this.state
    const filling = fillings.find((filling) => filling.id === id)

    if (filling?.name) {
      return filling?.slug
    } else {
      return 'none'
    }
  }

  _getKits = () => {
    const { general } = this.props
    const { user } = general
    getKits(user.user_id).then((res) => {
      let kits = res.data
      let kitsCopy = JSON.parse(JSON.stringify(kits))
      Object.keys(kitsCopy).map((k) => {
        Object.keys(kitsCopy[k]).map((kk) => {
          if (kitsCopy[k][kk]['Mattress'][0]) {
            delete kitsCopy[k][kk]['Mattress']
          }
        })
      })
      let kitsNoMattress = {}
      Object.keys(kitsCopy).map((k) => {
        let newKey = `${k} / No Mattress`
        kitsNoMattress[newKey] = kitsCopy[k]
      })
      let kitsAndKitsWithNoMattress = {}
      Object.keys(kits).map((k) => {
        kitsAndKitsWithNoMattress[k] = kits[k]
      })
      Object.keys(kitsNoMattress).map((k) => {
        kitsAndKitsWithNoMattress[k] = kitsNoMattress[k]
      })
      this.setState({ kits: kitsAndKitsWithNoMattress })
    })
  }

  checkForMobileLayout = debounce(() => {
    this.setState({ isMobileLayout: window.innerWidth <= 1199 })
  }, 100)

  checkForDesktopLayout = debounce(() => {
    this.setState({ isDesktopLayout: window.innerWidth <= 1599 })
  }, 100)

  _selectFabric = (fabrics, e, index) => {
    let name = e.target.value
    let id = fabrics.find((fabric) => fabric.name.toLowerCase() === name.toLowerCase()).id
    let fabric = fabrics.find((fabric) => fabric.name.toLowerCase() === name.toLowerCase())
    let fabricBrand, fabricSku, fabricColor, fabricYard, pa_sku, pa_fabric_material

    let fabricImage = fabric.images[0]?.src
    fabricBrand = fabric.attributes?.find((attr) => attr.name.toLowerCase() === 'brand')?.options[0]
    fabricSku = fabric.attributes?.find((attr) => attr.name.toLowerCase() === 'internal sku')
      ?.options[0]
    fabricColor = fabric.attributes?.find(
      (attr) => attr.name.toLowerCase() === 'internal color number:',
    )?.options[0]
    fabricYard = fabric.attributes?.find(
      (attr) => attr.name.toLowerCase() === 'ounces per sq yard:',
    )?.options[0]
    pa_fabric_material = fabric.attributes?.find((attr) => attr.name.toLowerCase() === 'material')
      ?.options[0]
    pa_sku = fabric?.sku

    fabric.attributes
      .find((attribute) => attribute.name.toLowerCase() === 'is directional')
      .options.map((option) => {
        if (option === 'yes') {
          this.setState({
            [`kitFabricDirection${index}`]: {},
          })
        }
        if (option === 'no') {
          this.setState({
            [`kitFabricDirection${index}`]: undefined,
          })
        }
      })

    this.setState({
      [`kitFabric${index}`]: {
        name: name,
        id: id,
        fabricBrand: fabricBrand,
        fabricSku: fabricSku,
        fabricColor: fabricColor,
        fabricYard: fabricYard,
        fabricImage: fabricImage,
        pa_sku: pa_sku,
        pa_fabric_material: pa_fabric_material,
      },
      [`kitCordingFabric${index}`]: {
        name: name,
        id: id,
        cordFabricBrand: fabricBrand,
        cordFabricSku: fabricSku,
        cordFabricColor: fabricColor,
        cordFabricYard: fabricYard,
        cordFabricImage: fabricImage,
        pa_cording_sku: pa_sku,
        pa_cording_fabric_material: pa_fabric_material,
      },
    })
  }

  _setSelectedFabricName = (fabrics, e) => {
    let name = e.target.value
    let id = fabrics.find((fabric) => fabric.name.toLowerCase() === name.toLowerCase())?.id

    this.setState({
      selectedFabricName: { name: name, id: id },
    })
  }

  _selectDirectionFabric = (directionalFabrics, e, index) => {
    let name = e.target.value
    let fabricDirectionName = directionalFabrics.find(
      (fabric) => fabric.fabric_direction_name.toLowerCase() === name.toLowerCase(),
    )?.fabric_direction

    if (name !== 'Select Fabric Direction') {
      this.setState({
        [`kitFabricDirection${index}`]: { fabric_direction: fabricDirectionName },
      })
    } else {
      this.setState({
        [`kitFabricDirection${index}`]: {},
      })
    }
  }

  _selectCordingFabric = (cordingFabrics, e, index) => {
    let name = e.target.value
    let id = cordingFabrics.find((fabric) => fabric.name.toLowerCase() === name.toLowerCase()).id
    let cordFabric = cordingFabrics?.find(
      (fabric) => fabric.name.toLowerCase() === name.toLowerCase(),
    )
    let cordFabricImage = cordFabric?.images[0]?.src
    let cordFabricBrand,
      cordFabricSku,
      cordFabricColor,
      cordFabricYard,
      pa_cording_sku,
      pa_cording_fabric_material
    pa_cording_sku = cordFabric?.sku

    cordFabricBrand = cordFabric?.attributes.find((attr) => attr.name.toLowerCase() === 'brand')
      ?.options[0]
    cordFabricSku = cordFabric?.attributes.find(
      (attr) => attr.name.toLowerCase() === 'internal sku',
    )?.options[0]
    cordFabricColor = cordFabric?.attributes.find(
      (attr) => attr.name.toLowerCase() === 'internal color number:',
    )?.options[0]
    cordFabricYard = cordFabric?.attributes.find(
      (attr) => attr.name.toLowerCase() === 'ounces per sq yard:',
    )?.options[0]
    pa_cording_fabric_material = cordFabric?.attributes.find(
      (attr) => attr.name.toLowerCase() === 'material',
    )?.options[0]

    this.setState({
      [`kitCordingFabric${index}`]: {
        name: name,
        id: id,
        cordFabricBrand: cordFabricBrand,
        cordFabricSku: cordFabricSku,
        cordFabricColor: cordFabricColor,
        cordFabricYard: cordFabricYard,
        cordFabricImage: cordFabricImage,
        pa_cording_sku: pa_cording_sku,
        pa_cording_fabric_material: pa_cording_fabric_material,
      },
    })
  }

  _setSelectedCordingFabricName = (fabrics, e) => {
    let name = e.target.value
    let id = fabrics.find((fabric) => fabric.name.toLowerCase() === name.toLowerCase())?.id

    this.setState({
      selectedCordingFabricName: { name: name, id: id },
    })
  }

  _setFillings = () => {
    const { kit, kitFabricsLength, fillings } = this.state
    if (kit) {
      const kitProductArray = Object.keys(kit).map((k, index) => {
        return Object.values(kit)[index][0]
      })
      if (kitProductArray.length !== kitFabricsLength + 1) {
        this.setState({
          kitFillings: kitProductArray.map((kitProduct, index) => {
            if (Object.keys(kit)[index] === 'Mattress') {
              let filling = fillings.find((filling) => filling.id === 723)
              return { name: filling.slug, id: filling.id }
            }
            if (
              Object.keys(kit)[index] === 'Bolsters' ||
              Object.keys(kit)[index] === 'Side Pillows'
            ) {
              let filling = fillings?.find((filling) => filling.id === 874)
              return { name: filling.slug, id: filling.id }
            }
            if (Object.keys(kit)[index] === 'Back Pillows') {
              let filling = fillings?.find((filling) => filling.id === 874)
              return { name: filling.slug, id: filling.id }
            }
            if (Object.keys(kit)[index] === 'Accent Pillows') {
              let filling = fillings?.find((filling) => filling.id === 874)
              return { name: filling.slug, id: filling.id }
            }
            if (
              Object.keys(kit)[index] === 'Lumbar Pillow' ||
              Object.keys(kit)[index] === 'Large Lumbar Pillow'
            ) {
              let filling = fillings?.find((filling) => filling.id === 874)
              return { name: filling.slug, id: filling.id }
            }
            if (
              Object.keys(kit)[index] === 'Small Pillows' ||
              Object.keys(kit)[index] === 'Small Lumbar Pillow'
            ) {
              let filling = fillings?.find((filling) => filling.id === 874)
              return { name: filling.slug, id: filling.id }
            }
            if (Object.keys(kit)[index] === 'Medium Pillows') {
              if (kitProduct.pa_product === 'toss') {
                let filling = fillings?.find((filling) => filling.id === 874)
                return { name: filling.slug, id: filling.id }
              }
              if (kitProduct.pa_product === 'bench-window-back') {
                let filling = fillings?.find((filling) => filling.id === 723)
                return { name: filling.slug, id: filling.id }
              }
            }
            if (Object.keys(kit)[index] === 'Medium Pillow') {
              if (kitProduct.pa_product === 'toss') {
                let filling = fillings?.find((filling) => filling.id === 874)
                return { name: filling.slug, id: filling.id }
              }
              if (kitProduct.pa_product === 'bench-window-back') {
                let filling = fillings?.find((filling) => filling.id === 723)
                return { name: filling.slug, id: filling.id }
              }
            }
            if (Object.keys(kit)[index] === 'Medium Toss Pillow') {
              let filling = fillings?.find((filling) => filling.id === 874)
              return { name: filling.slug, id: filling.id }
            }
            if (Object.keys(kit)[index] === 'Large Pillows') {
              if (kitProduct.pa_product === 'toss') {
                let filling = fillings?.find((filling) => filling.id === 874)
                return { name: filling.slug, id: filling.id }
              }
              if (kitProduct.pa_product === 'bench-window-back') {
                let filling = fillings?.find((filling) => filling.id === 723)
                return { name: filling.slug, id: filling.id }
              }
            }
            if (kitProduct['ordering notes'].includes('Densified Fiber Filing Material')) {
              let filling = fillings?.find((filling) => filling.id === 723)
              return { name: filling.slug, id: filling.id }
            }
            if (
              kitProduct['ordering notes'].includes('Poly-Bun') ||
              kitProduct['ordering notes'].includes('Poly-bun')
            ) {
              let filling = fillings?.find((filling) => filling.id === 874)
              return { name: filling.slug, id: filling.id }
            }
            if (!kitProduct.pa_filling) {
              return { name: '', id: '' }
            }
            if (kitProduct?.pa_filling) {
              return {
                name: this._setFillingsBasedOnId(kitProduct.pa_filling),
                id: kitProduct.pa_filling,
              }
            }
          }),
        })
      }
    }
  }

  _selectFilling = (fillings, e) => {
    const { selectedFiling, kitFabricsLength, kitFillings } = this.state
    let name = e.target.value
    let id = fillings.find((filling) => filling.name.toLowerCase() === name.toLowerCase())?.id
    if (kitFillings.length === kitFabricsLength) {
      const foundFilling = kitFillings.find((filling) => filling.id === selectedFiling.id)
      if (foundFilling) {
        let index = kitFillings.indexOf(foundFilling)
        let copyOfFillings = [...kitFillings]
        copyOfFillings[index] = { name: name.replace(' ', '-').toLowerCase(), id: id }
        this.setState({
          kitFillings: copyOfFillings,
        })
      }
    }
  }

  _setSelectedFiling = (e) => {
    const { fillings } = this.state

    let name = e.target.value
    let id = fillings.find((filling) => filling.name.toLowerCase() === name.toLowerCase())?.id

    this.setState({
      selectedFiling: { name: !name.includes('none') ? name.trim() : '', id: id ? id : '' },
    })
  }

  _selectKitStyle = (kits, e) => {
    const { dispatch } = this.props
    const { kitFabricsLength } = this.state
    let value = e.target.value
    let kit = kits[value]
    let isStyle6Selected = value.toLowerCase().includes('style 6')
    let numberOfItemsThatDoNotRequireCordingFabrics = 0
    let numberOfItemsInKit = 0
    let kitProducts = []

    for (let key in kit) {
      kitProducts.push(kit[key])
    }

    kitProducts.forEach((product) => {
      let productItems = []
      for (let key2 in product) {
        productItems.push(product[key2])
      }

      productItems.forEach((item) => {
        numberOfItemsInKit++
        if (
          item[0]['ordering notes']?.toLowerCase().includes('knife edge') ||
          item[0]['ordering notes']?.toLowerCase().includes('no welting')
        ) {
          numberOfItemsThatDoNotRequireCordingFabrics++
        }
      })
    })

    let allItemsDoNotRequireCordingFabrics =
      numberOfItemsThatDoNotRequireCordingFabrics === numberOfItemsInKit

    if (isStyle6Selected || allItemsDoNotRequireCordingFabrics) {
      this.setState({
        showCordingFabrics: false,
      })
    } else {
      this.setState({
        showCordingFabrics: true,
      })
    }

    dispatch(setSelectedKitStyle(kit, value))

    if (kitFabricsLength) {
      const indexes = Array.from({ length: kitFabricsLength }, (v, k) => k)
      indexes.forEach((index) => {
        this.setState({
          [`kitFabric${index}`]: {},
          [`kitCordingFabric${index}`]: {},
          kitsDetails: kit,
          kitFabricsLength: null,
        })
      })
    } else {
      this.setState({
        kitsDetails: kit,
        kitFabricsLength: null,
      })
    }
    this._resetDirectionalFabricsState()
  }

  _selectKitSize = (e) => {
    const { kitsDetails } = this.state
    const { dispatch } = this.props
    let value = e.target.value

    this.setState({
      lastKitSelection: value,
    })

    let kit = kitsDetails[value]

    dispatch(setSelectedKitSize(kit, value))

    this.setState(
      {
        kitFabrics: [],
        kitCordingFabrics: [],
        kit: kit,
        kitFabricsLength: Object.keys(kit).length,
      },
      () => {
        this._setFillings()
        this._setDropdownsState()
      },
    )
  }

  _getAllFabrics = () => {
    const { dispatch, fabrics, general } = this.props
    const { user } = general

    if (user.user_name?.toLowerCase() === 'westchase') {
      getWestchaseFabrics(
        'per_page=800&page=1&orderby=title&order=asc&attribute=pa_westchase&attribute_term=2989',
      ).then((res) => {
        dispatch({ type: 'SET_ALL_FABRICS_FOR_KITS', payload: { fabricsKits: res } })
        this.setState({ fabrics: res })
      })
    } else {
      if (fabrics.fabricsKits) {
        this.setState({ fabrics: fabrics.fabricsKits })
      } else {
        dispatch(getFabricsForKits())

        this.setState({ fabrics: fabrics.fabricsKits })
      }
    }
  }

  _addCushionToCartPromise = (item) => {
    const { dispatch } = this.props
    const { kitQty } = this.state
    let cartKey = localStorage.getItem('cartKey')
    return new Promise((resolve) => {
      setTimeout(() => {
        return CoCart.post('cart/add-item', {
          id: item.product_id.toString(),
          quantity: (parseInt(item.quantity) * kitQty).toString(),
          item_data: item,
        })
          .then((res) => {
            if (!cartKey) {
              localStorage.setItem('cartKey', res.data.cart_key)
              cartKey = res.data.cart_key
            }
            resolve(res)
            dispatch({ type: 'ADD_TO_CART_SUCCESS' })
            if (res) {
              this.setState((prevState) => ({
                cartResponses: [...prevState.cartResponses, res],
              }))
            }
          })
          .catch(() => {
            dispatch({ type: 'ADD_TO_CART_FAILED' })
            displayToast('There is an error trying to add items to cart', 'error')
          })
      }, 100)
    })
  }

  _executeSequentially = (items) => {
    const element = items.shift()
    return this._addCushionToCartPromise(element).then((item) =>
      items.length === 0 ? item : this._executeSequentially(items),
    )
  }

  _addToCart = () => {
    const { kit, kitFillings, shapes, fasteners, styles, fillings } = this.state
    const { kit: kitProps } = this.props
    const { nameOfSize, nameOfStyle } = kitProps

    this.setState({ addToCartPressed: true })

    const itemsData = []

    for (let i = 0; i < Object.keys(kit).length; i++) {
      // eslint-disable-next-line react/destructuring-assignment
      const fabricDirection = this.state[`kitFabricDirection${i}`]
      // eslint-disable-next-line react/destructuring-assignment
      const kitFabricState = this.state[`kitFabric${i}`]
      // eslint-disable-next-line react/destructuring-assignment
      const kitCordingFabricState = this.state[`kitCordingFabric${i}`]
      const kitItem = Object.keys(kit)[i]
      const itemData = {
        type: 'basic_product',
        fabric: {
          fabric_id: kitFabricState?.id?.toString(),
          fabric_name: kitFabricState?.name,
          fabric_direction: fabricDirection?.fabric_direction || 'nondirectional',
          image: kitFabricState?.fabricImage,
          pa_fabric_material: kitFabricState?.pa_fabric_material,
        },
      }
      // fabric data
      itemData.pa_attribute_brand = kitFabricState?.fabricBrand || ''
      itemData.pa_attribute_internal_sku = kitFabricState?.fabricSku || ''
      itemData.pa_attribute_internal_color_number = kitFabricState?.fabricColor || ''
      itemData.pa_attribute_fabric_required = kitFabricState?.fabricYard || ''

      itemData.pa_sku = kitFabricState?.pa_sku || ''

      // product
      itemData.attribute_pa_product = kitItem.trim().toString()

      // dimensions data
      itemData.attribute_pa_width = kit[kitItem][0].pa_width
        ? kit[kitItem][0]?.pa_width.toString()
        : ''
      itemData.attribute_pa_height = kit[kitItem][0].pa_height
        ? kit[kitItem][0]?.pa_height.toString()
        : ''
      itemData.attribute_pa_back_height = kit[kitItem][0].pa_back_height
        ? kit[kitItem][0]?.pa_back_height.toString()
        : ''
      itemData.attribute_pa_shape = kit[kitItem][0].pa_shape
        ? shapes.find((shape) => shape.id === kit[kitItem][0]?.pa_shape)?.slug
        : ''
      itemData.attribute_pa_depth = kit[kitItem][0].pa_depth
        ? kit[kitItem][0]?.pa_depth.toString()
        : ''
      itemData.attribute_pa_thickness = kit[kitItem][0].pa_thickness
        ? kit[kitItem][0]?.pa_thickness.toString()
        : ''
      itemData.attribute_pa_back_thickness = kit[kitItem][0]?.pa_back_thickness
        ? kit[kitItem][0]?.pa_back_thickness.toString()
        : ''
      itemData.attribute_pa_seat_thickness = kit[kitItem][0]?.pa_seat_thickness
        ? kit[kitItem][0]?.pa_seat_thickness.toString()
        : ''
      itemData.attribute_pa_diameter = kit[kitItem][0]?.pa_diameter
        ? kit[kitItem][0]?.pa_diameter.toString()
        : ''

      // style and size
      itemData.KIT_STYLE = nameOfStyle
      itemData.KIT_SIZE = nameOfSize
      itemData.attribute_pa_size = nameOfSize

      if (kit[kitItem][0]?.attribute_pa_section_1) {
        itemData.attribute_pa_section_1 = kit[kitItem][0]?.attribute_pa_section_1?.toString()
      }

      if (kit[kitItem][0]?.attribute_pa_section_2) {
        itemData.attribute_pa_section_2 = kit[kitItem][0]?.attribute_pa_section_2?.toString()
      }

      if (kit[kitItem][0]?.attribute_pa_section_3) {
        itemData.attribute_pa_section_3 = kit[kitItem][0]?.attribute_pa_section_3?.toString()
      }

      if (kit[kitItem][0]?.attribute_pa_section_4) {
        itemData.attribute_pa_section_4 = kit[kitItem][0]?.attribute_pa_section_4?.toString()
      }

      // dimension image
      let img_link

      if (
        kit[kitItem][0]?.pa_product.toString() === 'bed-cushion' ||
        kit[kitItem][0]?.pa_product.toString() === 'bench-window-back' ||
        kit[kitItem][0]?.pa_product.toString() === 'bench-window-seat'
      ) {
        if (kit[kitItem][0]?.pa_shape === 29) {
          img_link = `${APP_URL}/wp-content/uploads/2021/12/squared-corners-dimensions-2d.png`
        }
        if (kit[kitItem][0]?.pa_shape === 30) {
          img_link = `${APP_URL}/wp-content/uploads/2021/12/rounded-corners-dimensions-2d.png`
        }
        if (kit[kitItem][0]?.pa_shape === 727) {
          img_link = `${APP_URL}/wp-content/uploads/2021/12/rounded-front-dimensions-2d.png`
        }
        if (kit[kitItem][0]?.pa_shape === 728) {
          img_link = `${APP_URL}/wp-content/uploads/2021/12/rounded-back-dimensions-2d.png`
        }
        if (kit[kitItem][0]?.pa_shape === 729) {
          img_link = `${APP_URL}/wp-content/uploads/2022/02/bed-cushion-trapezoid-dimensions-2d.png`
        }
      }

      if (kit[kitItem][0]?.pa_product.toString() === 'toss') {
        if (kit[kitItem][0]?.pa_shape === 29) {
          img_link = `${APP_URL}/wp-content/uploads/2021/12/squared-corners-dimensions-2d.png`
        }
        if (kit[kitItem][0]?.pa_shape === 30) {
          img_link = `${APP_URL}/wp-content/uploads/2021/12/rounded-corners-dimensions-2d.png`
        }
        if (kit[kitItem][0]?.pa_shape === 727) {
          img_link = `${APP_URL}/wp-content/uploads/2021/12/rounded-front-dimensions-2d.png`
        }
        if (kit[kitItem][0]?.pa_shape === 728) {
          img_link = `${APP_URL}/wp-content/uploads/2021/12/rounded-back-dimensions-2d.png`
        }
        if (kit[kitItem][0]?.pa_shape === 729) {
          img_link = `${APP_URL}/wp-content/uploads/2022/02/bed-cushion-trapezoid-dimensions-2d.png`
        }
      }

      if (kit[kitItem][0]?.pa_product.toString() === 'bolster') {
        img_link = `${APP_URL}/wp-content/uploads/2022/01/bolster-dimensions-2d.png`
      }

      if (kit[kitItem][0]?.pa_product.toString() === 'toss') {
        img_link = `${APP_URL}/wp-content/uploads/2022/01/toss-dimensions-2d.png`
      }

      if (kit[kitItem][0]?.pa_product.toString() === 'lumbar') {
        img_link = `${APP_URL}/wp-content/uploads/2022/01/lumbar-dimensions-2d.png`
      }

      itemData.pa_dimensions_image = img_link

      // filling
      if (kitFillings[i]?.id) {
        itemData.attribute_pa_filling = {
          [kitFillings[i].id]: kitFillings[i].id
            ? fillings.find((filling) => filling.id === kitFillings[i]?.id)?.slug
            : '',
        }
      }

      // set
      if (kit[kitItem][0]?.pa_set) {
        itemData.attribute_pa_set = kit[kitItem][0]?.pa_set
          ? kit[kitItem][0]?.pa_set.toString()
          : ''
      }

      // fasteners
      if (kit[kitItem][0]?.pa_fasteners) {
        itemData.attribute_pa_fasteners = kit[kitItem][0].pa_fasteners
          ? fasteners.find((fastener) => fastener.id === kit[kitItem][0]?.pa_fasteners)?.slug
          : ''
      }

      // style
      if (kit[kitItem][0]?.pa_style) {
        itemData.attribute_pa_style = kit[kitItem][0].pa_style
          ? styles.find((style) => style.id === kit[kitItem][0]?.pa_style)?.slug
          : ''

        //cord fabric data
        if (itemData.attribute_pa_style !== ('knife-edge' || 'no-welting-box-edge')) {
          itemData.attribute_pa_cord_fabric_id = kitCordingFabricState?.id?.toString()
          itemData.attribute_pa_cord_fabric_name = kitCordingFabricState?.name
          itemData.pa_attribute_cording_fabric_required =
            kitCordingFabricState?.cordFabricYard || ''
          itemData.pa_attribute_cording_brand = kitCordingFabricState?.cordFabricBrand || ''
          itemData.pa_attribute_cording_internal_sku = kitCordingFabricState?.cordFabricSku || ''
          itemData.pa_attribute_cording_internal_color_number =
            kitCordingFabricState?.cordFabricColor || ''
          itemData.cord_fabric_image = kitCordingFabricState?.cordFabricImage
          itemData.pa_cording_sku = kitCordingFabricState?.pa_cording_sku || ''
          itemData.pa_cording_fabric_material =
            kitCordingFabricState?.pa_cording_fabric_material || ''
        }
      }

      // type
      itemData.product_id = kit[kitItem][0]?.product_id.toString()
      itemData.product_name = kit[kitItem][0]?.pa_product.toString()

      // quantity
      itemData.quantity = kit[kitItem][0]?.quantity.toString()

      // edit link
      let category =
        kit[kitItem][0]?.pa_product.toString() === 'bed-cushion'
          ? '884'
          : kit[kitItem][0]?.pa_product.toString() === 'toss' ||
              kit[kitItem][0]?.pa_product.toString() === 'bolster'
            ? '27'
            : kit[kitItem][0]?.pa_product.toString() === 'bench-window-back'
              ? '769'
              : '27'

      let dimensionsOrder

      let fabricURL = `${kitFabricState?.id}-${fabricDirection?.fabric_direction ? fabricDirection?.fabric_direction : 'nondirectional'}-${kitFabricState?.name.toLowerCase().replace(' ', '-')}`
      let cordFabricURL = `${kit[kitItem][0]?.pa_style}-${kitCordingFabricState?.id}-${fabricDirection?.fabric_direction ? fabricDirection?.fabric_direction : 'nondirectional'}-${kitCordingFabricState?.name.toLowerCase().replace(' ', '-')}`
      let fastenersURL = `/${kit[kitItem][0]?.pa_fasteners ? kit[kitItem][0]?.pa_fasteners + '-' + fasteners.find((fastener) => fastener.id === kit[kitItem][0]?.pa_fasteners)?.slug : ''}`
      let fillingURL = `${kitFillings[i]?.id ? kitFillings[i]?.id + '-' + fillings.find((filling) => filling.id === kitFillings[i]?.id)?.slug : ''}`

      if (
        kit[kitItem][0]?.pa_product.toString() === 'bed-cushion' ||
        kit[kitItem][0]?.pa_product.toString() === 'bench-window-back' ||
        kit[kitItem][0]?.pa_product.toString() === 'bench-window-seat'
      ) {
        dimensionsOrder = `${kit[kitItem][0]?.pa_thickness}-${kit[kitItem][0]?.pa_width}-${kit[kitItem][0]?.pa_depth}`
      }

      if (kit[kitItem][0]?.pa_product.toString() === 'bolster') {
        dimensionsOrder = `${kit[kitItem][0]?.pa_width}-${kit[kitItem][0]?.pa_diameter}`
      }

      if (
        kit[kitItem][0]?.pa_product.toString() === 'toss' ||
        kit[kitItem][0]?.pa_product.toString() === 'lumbar'
      ) {
        dimensionsOrder = `${kit[kitItem][0]?.pa_height}-${kit[kitItem][0]?.pa_width}`
      }

      let product_edit_link = `${APP_URL}/cd/${category}/${kit[kitItem][0]?.product_id}-${kit[kitItem][0]?.pa_product}${kit[kitItem][0].pa_shape ? '/' + kit[kitItem][0].pa_shape + '-' + shapes.find((shape) => shape.id === kit[kitItem][0]?.pa_shape)?.slug : ''}/${dimensionsOrder}/${fabricURL}/${cordFabricURL}${fastenersURL}/${fillingURL}`

      itemData.product_edit_link = product_edit_link

      itemsData.push(itemData)
    }

    this._executeSequentially(itemsData).then(() => {
      setTimeout(() => {
        this._redirectToCart()
      }, 200)
    })
  }

  _redirectToCart = () => {
    this.setState({
      cartResponses: [],
    })

    window.location = `${APP_URL}/cart`
  }

  _resetDirectionalFabricsState = () => {
    const { kitFabricsLength } = this.state

    const indexes = Array.from({ length: kitFabricsLength }, (v, k) => k)
    indexes.map((index) => {
      // eslint-disable-next-line react/destructuring-assignment
      let directionState = this.state[`kitFabricDirection${index}`]
      if (isObject(directionState) && !isEmpty(directionState)) {
        this.setState({
          [`kitFabricDirection${index}`]: undefined,
        })
      }
      if (isObject(directionState)) {
        this.setState({
          [`kitFabricDirection${index}`]: undefined,
        })
      }
    })
  }

  _clear = () => {
    const { dispatch } = this.props
    this._resetDirectionalFabricsState()
    dispatch({ type: 'KIT_RESET' })
    this.setState(
      {
        kitsDetails: null,
        kit: null,
        kitFabrics: [],
        kitCordingFabrics: [],
        selectedFabricName: null,
        selectedCordingFabricName: null,
        kitFabricsLength: null,
        kits: [],
      },
      () => {
        this._getKits()
      },
    )
  }

  _openTooltip = () => {
    displayToast('First you need to select the fabrics', 'error')
  }

  capitalizeTheFirstLetterOfEachWord(words) {
    let separateWord = words?.toLowerCase().split(' ')
    for (let i = 0; i < separateWord?.length; i++) {
      separateWord[i] = separateWord[i].charAt(0).toUpperCase() + separateWord[i].substring(1)
    }
    return separateWord?.join(' ')
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.checkForMobileLayout)
    window.removeEventListener('resize', this.checkForDesktopLayout)
  }

  render() {
    const {
      disabeled,
      kits,
      kitsDetails,
      kit,
      addToCartPressed,
      fillings,
      isMobileLayout,
      directionalFabricsOptions,
      kitQty,
      kitQtyInputWidth,
      showCordingFabrics,
      kitFillings,
    } = this.state
    const { fabrics, kit: kitProps } = this.props
    const { nameOfStyle, nameOfSize, size } = kitProps
    const allFabrics = fabrics?.fabricsKits
    let style13 = kits['Style 13']

    return allFabrics && Object.keys(kits).length > 0 && fillings.length > 0 ? (
      <div className={'background'}>
        <p className="kits-title">Kits</p>
        <div className="first-dropdowns">
          <div className="dropdown-container">
            <p>Select your style</p>
            <select
              value={nameOfStyle ? nameOfStyle : 'Select Kit Style'}
              id="style-select"
              className="dropdown-button-container"
              onChange={(e) => this._selectKitStyle(kits, e)}
            >
              {nameOfStyle ? null : <option>Select Kit Style</option>}
              {Object.keys(kits).map((kit, index) => {
                return (
                  <option key={index} id={index} value={kit}>
                    {kit}
                  </option>
                )
              })}
            </select>
            <br />
            {kitsDetails ? (
              <>
                <p>Select your size</p>
                <select
                  value={kit ? nameOfSize : 'Select Kit Size'}
                  id="size-select"
                  className="dropdown-button-container"
                  onChange={(e) => this._selectKitSize(e)}
                >
                  {kit ? null : <option>Select Kit Size</option>}
                  {Object.keys(kitsDetails).map((kitDetails, index) => {
                    return (
                      <option key={index} id={index} value={kitDetails}>
                        {kitDetails}
                      </option>
                    )
                  })}
                </select>
              </>
            ) : null}
            <br />
          </div>
        </div>
        {kitsDetails ? (
          <div className={'kits'}>
            {isMobileLayout ? null : kit || size ? (
              <div className={'kit-title'}>
                <div
                  className={
                    showCordingFabrics
                      ? 'title title-product'
                      : 'title title-product title-product-no-cording'
                  }
                >
                  <p>Product</p>
                </div>
                <div
                  className={
                    showCordingFabrics ? 'title title-qty' : 'title title-qty title-qty-no-cording'
                  }
                >
                  <p>Qty</p>
                </div>
                <div
                  className={
                    showCordingFabrics
                      ? 'title title-ordering-notes'
                      : 'title title-ordering-notes title-ordering-notes-no-cording'
                  }
                >
                  <p>Ordering Notes</p>
                </div>
                <div
                  className={
                    showCordingFabrics
                      ? 'title title-filling'
                      : 'title title-filling title-filling-no-cording'
                  }
                >
                  <p>Filling</p>
                </div>
                <div
                  className={
                    showCordingFabrics ? 'title title-fabrics' : 'title title-fabrics-no-cording'
                  }
                >
                  <p>Fabrics</p>
                </div>
                <div className={'title title-cording-fabrics'}>
                  {showCordingFabrics ? <p>Cording Fabrics</p> : null}
                </div>
              </div>
            ) : null}
            {kit || size ? (
              <div>
                <div className={'kits-container'}>
                  {kitFillings.length &&
                    Object.keys(kit).map((k, index) => {
                      let kitProduct = Object.values(kit)[index][0]
                      let separator =
                        index === Object.keys(kit).length - 1
                          ? 'separator'
                          : isMobileLayout
                            ? 'separatorWithBiggerLine'
                            : 'separatorWithLine'
                      let copyOfFillings = [...fillings].filter((filling) => filling.id !== 726)
                      if (k === 'Mattress') {
                        copyOfFillings = [...fillings].filter((filling) =>
                          [722, 724, 725, 723].includes(filling.id),
                        )
                        let filling = [...fillings].find((filling) => filling.id === 723)
                        copyOfFillings.splice(copyOfFillings.indexOf(filling), 1)
                        copyOfFillings.unshift(filling)
                      }
                      if (k === 'Bolsters') {
                        copyOfFillings = [...fillings].filter((filling) =>
                          [873, 874].includes(filling.id),
                        )
                        let filling = copyOfFillings.find((filling) => filling.id === 874)
                        copyOfFillings.splice(copyOfFillings.indexOf(filling), 1)
                        copyOfFillings.unshift(filling)
                      }
                      if (k === 'Back Pillows' || k === 'Accent Pillows' || k === 'Side Pillows') {
                        copyOfFillings = [...fillings].filter((filling) =>
                          [873, 874].includes(filling.id),
                        )
                        let filling = copyOfFillings.find((filling) => filling.id === 874)
                        copyOfFillings.splice(copyOfFillings.indexOf(filling), 1)
                        copyOfFillings.unshift(filling)
                      }
                      if (k === 'Medium Pillows' || k === 'Large Pillows') {
                        copyOfFillings = [...fillings].filter((filling) =>
                          [874, 722, 724, 725, 723].includes(filling.id),
                        )
                      }
                      if (
                        kitProduct['ordering notes'].includes('Poly-bun') ||
                        kitProduct['ordering notes'].includes('Poly-Bun')
                      ) {
                        let filling = copyOfFillings.find((filling) => filling.id === 874)
                        copyOfFillings.splice(copyOfFillings.indexOf(filling), 1)
                        copyOfFillings.unshift(filling)
                      }
                      if (
                        kitProduct['ordering notes'].includes('Densified Fiber Filling Material')
                      ) {
                        let filling = [...fillings].find((filling) => filling.id === 723)
                        copyOfFillings.splice(copyOfFillings.indexOf(filling), 1)
                        copyOfFillings.unshift(filling)
                      }
                      return (
                        <div className={`kit ${separator}`} key={index}>
                          <div className={'kit-product'}>
                            {isMobileLayout ? (
                              <div className={'title-mobile'}>
                                <p>Product: </p>
                              </div>
                            ) : null}
                            <div className={'product'}>
                              <p>
                                {k} {kitProduct.pa_width ? `- ${kitProduct.pa_width}w` : null}{' '}
                                {style13['king']['Side Pillows']
                                  ? kitProduct.pa_thickness
                                    ? `x ${kitProduct.pa_thickness}h`
                                    : null
                                  : kitProduct.pa_depth
                                    ? `x ${kitProduct.pa_depth}d`
                                    : null}{' '}
                                {style13['king']['Side Pillows']
                                  ? kitProduct.pa_depth
                                    ? `x ${kitProduct.pa_depth}d`
                                    : null
                                  : kitProduct.pa_thickness
                                    ? `x ${kitProduct.pa_thickness}h`
                                    : null}{' '}
                                {kitProduct.pa_diameter ? `x ${kitProduct.pa_diameter}dia` : null}{' '}
                                {kitProduct.pa_height ? `x ${kitProduct.pa_height}h` : null}{' '}
                                {kitProduct.pa_back_height
                                  ? `x ${kitProduct.pa_back_height}bh`
                                  : null}{' '}
                                {kitProduct.pa_back_thickness
                                  ? `x ${kitProduct.pa_back_thickness}bt`
                                  : null}{' '}
                                {kitProduct.pa_seat_thickness
                                  ? `x ${kitProduct.pa_seat_thickness}`
                                  : null}{' '}
                                in.
                              </p>
                            </div>
                          </div>
                          <div className={'kit-qty'}>
                            {isMobileLayout ? (
                              <div className={'title-mobile'}>
                                <p>Quantity:</p>
                              </div>
                            ) : null}
                            <div className={'qty'}>
                              <p>{kitProduct.quantity}</p>
                            </div>
                          </div>
                          <div className={'kit-ordering-notes'}>
                            {isMobileLayout ? (
                              <div className={'title-mobile'}>
                                <p>Ordering Notes:</p>
                              </div>
                            ) : null}
                            <div className={'ordering-notes'}>
                              <p>{kitProduct['ordering notes']}</p>
                            </div>
                          </div>
                          <div className={'kit-filling'}>
                            {isMobileLayout ? (
                              <div className={'title-mobile'}>
                                <p>Filling:</p>
                              </div>
                            ) : null}
                            <div className={'filling'}>
                              <div className={'dropdown-container'}>
                                <select
                                  defaultValue={this.capitalizeTheFirstLetterOfEachWord(
                                    kitFillings[index]?.name?.replaceAll('-', ' '),
                                  )}
                                  id={`filling-${index}`}
                                  onClick={(e) => this._setSelectedFiling(e)}
                                  onInput={(e) => this._selectFilling(fillings, e, index)}
                                  className={`dropdown-button-container filling-dropdown-${index}`}
                                >
                                  {[...new Set(copyOfFillings)].map((filling, index) => {
                                    return (
                                      <option key={index} id={filling.id} value={filling.name}>
                                        {filling.name}
                                      </option>
                                    )
                                  })}
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className={'fabrics-dropdown'}>
                            {isMobileLayout ? (
                              <div className={'title-mobile'}>
                                <p>Fabrics:</p>
                              </div>
                            ) : null}
                            <div className={'dropdown-container'}>
                              <select
                                // defaultValue={ this.capitalizeTheFirstLetterOfEachWord(kitFabrics[index]?.name?.replaceAll('-', ' ')) }
                                id={`fabric-${index}`}
                                onChange={(e) => this._selectFabric(allFabrics, e, index)}
                                onClick={(e) => this._setSelectedFabricName(allFabrics, e)}
                                className={`dropdown-button-container fabric-dropdown-${index}`}
                              >
                                {
                                  // eslint-disable-next-line react/destructuring-assignment
                                  !isEmpty(this.state[`kitFabric${index}`]) ? (
                                    <option>{this.state[`kitFabric${index}`].name}</option>
                                  ) : (
                                    <option>Select Fabric</option>
                                  )
                                }
                                {allFabrics?.map((fabric) => {
                                  return (
                                    <option key={fabric.id} id={fabric.id} value={fabric.name}>
                                      {fabric.name}
                                    </option>
                                  )
                                })}
                              </select>
                              {
                                // eslint-disable-next-line react/destructuring-assignment
                                typeof this.state[`kitFabricDirection${index}`] === 'object' ? (
                                  <>
                                    <br />
                                    <select
                                      id={`fabric-direction-${index}`}
                                      onChange={(e) =>
                                        this._selectDirectionFabric(
                                          directionalFabricsOptions,
                                          e,
                                          index,
                                        )
                                      }
                                      className={`dropdown-button-container fabric-dropdown-${index}`}
                                    >
                                      {
                                        // eslint-disable-next-line react/destructuring-assignment
                                        this.state[`kitFabricDirection${index}`] !== null &&
                                        !isEmpty(this.state[`kitFabricDirection${index}`]) ? (
                                          <option>
                                            {
                                              this.state[`kitFabricDirection${index}`]
                                                .fabric_direction_name
                                            }
                                          </option>
                                        ) : (
                                          <option>Select Fabric Direction</option>
                                        )
                                      }
                                      {directionalFabricsOptions.map((fabric) => {
                                        return (
                                          <option
                                            key={fabric.id}
                                            id={fabric.id}
                                            value={fabric.fabric_direction_name}
                                          >
                                            {fabric.fabric_direction_name}
                                          </option>
                                        )
                                      })}
                                    </select>
                                  </>
                                ) : null
                              }
                            </div>
                          </div>
                          {showCordingFabrics ? (
                            <div className={'fabrics-dropdown'}>
                              {isMobileLayout ? (
                                <div className={'title-mobile'}>
                                  {kitProduct['ordering notes'].includes('Knife Edge') ||
                                  kitProduct['ordering notes'].includes('No Welting') ? null : (
                                    <p>Cording Fabrics:</p>
                                  )}
                                </div>
                              ) : null}
                              <div className={'dropdown-container'}>
                                {kitProduct['ordering notes'].includes('Knife Edge') ||
                                kitProduct['ordering notes'].includes('No Welting') ? (
                                  <div className="dropdown-button-container-just-for-space"></div>
                                ) : (
                                  <select
                                    id={`cording-fabric-${index}`}
                                    onChange={(e) =>
                                      this._selectCordingFabric(allFabrics, e, index)
                                    }
                                    onClick={(e) =>
                                      this._setSelectedCordingFabricName(allFabrics, e)
                                    }
                                    className={`dropdown-button-container cording-fabric-dropdown-${index}`}
                                  >
                                    {
                                      // eslint-disable-next-line react/destructuring-assignment
                                      !isEmpty(this.state[`kitCordingFabric${index}`]) ? (
                                        <option>
                                          {this.state[`kitCordingFabric${index}`].name}
                                        </option>
                                      ) : (
                                        <option>Select Cording Fabric</option>
                                      )
                                    }
                                    {allFabrics.map((fabric) => {
                                      return (
                                        <option key={fabric.id} id={fabric.id} value={fabric.name}>
                                          {fabric.name}
                                        </option>
                                      )
                                    })}
                                  </select>
                                )}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      )
                    })}
                  <div className="bottom-elements">
                    <div className="kit-quantity">
                      <p>Kit qty:</p>
                      <input
                        id="kit-quantity"
                        className="quantity-input"
                        type="number"
                        min={1}
                        max={100}
                        style={{ width: kitQtyInputWidth }}
                        value={kitQty}
                        onChange={(e) => this._setQty(e)}
                      />
                    </div>
                    <button id="clear" onClick={this._clear} className="clear-button" type="button">
                      <p>Clear</p>
                    </button>
                  </div>
                </div>
                <div className={'add-to-cart-container'}>
                  <button
                    id="add-to-cart"
                    className={disabeled ? 'disabled-button' : 'active-button'}
                    onClick={disabeled ? this._openTooltip : this._addToCart}
                    type={'button'}
                  >
                    <p>Add to Cart</p>
                    {addToCartPressed ? (
                      <span className="clip-loader">
                        <ClipLoader color="green" />
                      </span>
                    ) : null}
                  </button>
                </div>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    ) : (
      <div className="barloader-kits-container">
        <BarLoader
          color={'#93C44E'}
          css={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  fabrics: state.fabrics,
  general: state.general,
  kit: state.kit,
  layout: state.layout,
})

export default withRoutingTracker(connect(mapStateToProps)(Kit))
